import React from 'react';
import ERROR_404 from "../../global/assets/svg/Error404.svg";
import AtomicButton from '../../atomic/button/AtomicButton';
import variables from "../../global/assets/_variables.scss";
import { isMobile, isDesktop, isIpad } from '../../global/ScreenSizeHelper'
import { ERROR_404_MSG } from "../../global/constants";

export const Error404Desktop = () => {
    const styleButton = {
        backgroundColor: variables.backgroundButtonBlue,
        width: "90%",
        marginTop: "15px",
        marginBottom: "15px",
        height: "46px",
        width: "266px"
    };
    const tryAgain = () => {
        window.location.reload()
    };
    return (
        <div className={`error-404-container ${isIpad ? "ipad" : ""}`}>
            <div className='sorry-try-container'>
                <div className='sorry-text'>{ERROR_404_MSG}</div>
                <AtomicButton
                    label="Try again"
                    handleSubmit={tryAgain}
                    style={styleButton}
                />
            </div>
            <div>
                <img src={ERROR_404} alt="" />
            </div>
        </div>
    )
}
